var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#4BD667"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7546 9.23312C16.9151 9.07256 16.9151 8.81223 16.7546 8.65167C16.594 8.49111 16.3337 8.49111 16.1731 8.65167L10.3673 14.4575L7.83826 11.7177C7.68424 11.5509 7.42413 11.5405 7.25728 11.6945C7.09042 11.8485 7.08002 12.1086 7.23404 12.2755L10.0533 15.3297C10.1292 15.4119 10.2353 15.4597 10.3472 15.4619C10.4591 15.4641 10.567 15.4207 10.6461 15.3416L16.7546 9.23312Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckbox);
export default __webpack_public_path__ + "static/media/icon_checkbox.7e4432ee.svg";
export { ForwardRef as ReactComponent };